import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const children: RouteConfig[] = [
  {
    path: 'create/:id',
    name: 'createActivity',
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/createActivity.vue'),
    meta: {
      title: '活动发布'
    }
  },
  {
    path: 'list',
    name: 'activityList',
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/activityList.vue'),
    meta: {
      title: '活动列表'
    }
  },
  {
    path: 'applyList/:activityId',
    name: 'activity_applylist',
    component: () => import(/* webpackChunkName: "activity" */'@/views/activity/applyList.vue'),
    meta: {
      title: '报名管理'
    }
  }]


const activityRouter: RouteConfig = {
  path: '/activity',
  name: '活动管理',
  component: Layout,
  redirect: '/activity/list',
  meta: {
    title: '活动管理'
  },
  children: children
}

export default activityRouter
